var map = {
	"./de/btn-detail.png": "stN7",
	"./en/btn-detail.png": "9vdl",
	"./es/btn-detail.png": "t1QT",
	"./fr/btn-detail.png": "csJP",
	"./ja/btn-detail.png": "K6sQ",
	"./ko/btn-detail.png": "QTH7",
	"./pt/btn-detail.png": "EYft",
	"./ru/btn-detail.png": "KDWn",
	"./th/btn-detail.png": "LUOO",
	"./zh-Hant/btn-detail.png": "yeUT"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "LUkE";